import { render } from "./Idle.vue?vue&type=template&id=e2761e12"
import script from "./Idle.vue?vue&type=script&lang=js"
export * from "./Idle.vue?vue&type=script&lang=js"

import "./Idle.vue?vue&type=style&index=0&id=e2761e12&lang=scss"
script.render = render

export default script